import actionTypes from '../actionTypes';

export const getTeams = () => ({
  type: actionTypes.TEAMS_GET_REQUEST,
});

export const getTeam = (teamId) => ({
  type: actionTypes.TEAM_GET_REQUEST,
  teamId,
});

export const selectTeam = (team) => ({
  type: actionTypes.TEAM_SELECT,
  team,
});

export const createTeam = (team) => ({
  type: actionTypes.TEAM_CREATE_REQUEST,
  team,
});

export const updateTeam = (teamId, team) => ({
  type: actionTypes.TEAM_UPDATE_REQUEST,
  teamId,
  team,
});

export const deleteTeam = (teamId) => ({
  type: actionTypes.TEAM_DELETE_REQUEST,
  teamId,
});

export const archiveTeam = (teamId) => ({
  type: actionTypes.TEAM_ARCHIVE_REQUEST,
  teamId,
});

export const recoverTeam = (teamId) => ({
  type: actionTypes.TEAM_RECOVER_REQUEST,
  teamId,
});



// WEBPACK FOOTER //
// src/redux/actions/teams.js